/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { defineRouting } from 'next-intl/routing'

import { REGIONS } from '@/utils/regions'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: REGIONS.map((region) => region.slug),

  // Used when no locale matches
  defaultLocale: 'en-gb',

  // Region selection is explicit in the public URL. Unprefixed requests always
  // use the default English locale and Proxy redirects them to /en-gb/.
  localeDetection: false,

  // The locale segment is the public region slug. Translation messages are
  // selected from the region's language in request.ts.
  localePrefix: 'always',
})
